var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "mt-3" },
    [
      _c(
        "b-row",
        {
          staticClass: "arrivals-table-header",
          attrs: { "align-v": "center" },
        },
        [
          _c(
            "b-col",
            { staticClass: "arrivals-header-name", attrs: { sm: "6" } },
            [
              _vm.search
                ? _c(
                    "b-input-group",
                    [
                      _c("b-form-input", {
                        attrs: { placeholder: _vm.$t("search") },
                        model: {
                          value: _vm.filter,
                          callback: function ($$v) {
                            _vm.filter = $$v
                          },
                          expression: "filter",
                        },
                      }),
                    ],
                    1
                  )
                : _vm._e(),
            ],
            1
          ),
          _vm._v(" "),
          _c("b-col", { staticClass: "text-right", attrs: { sm: "6" } }, [
            _c(
              "span",
              {
                staticStyle: { cursor: "pointer" },
                attrs: { title: "Download Report" },
                on: { click: _vm.downloadReport },
              },
              [_c("i", { staticClass: "fi fi-download" })]
            ),
          ]),
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "b-table",
        {
          class: ["analytics-tables table-has-border", _vm.tableClass],
          attrs: {
            responsive: "",
            "show-empty": "",
            striped: "",
            stacked: _vm.stacked,
            filter: _vm.filter,
            items: _vm.items,
            fields: _vm.fields,
            "empty-text": "No Data Available For Selected Date Range",
          },
          scopedSlots: _vm._u([
            {
              key: "empty",
              fn: function (scope) {
                return [_c("h6", [_vm._v(_vm._s(scope.emptyText))])]
              },
            },
          ]),
        },
        [_vm._t("custom-slots")],
        2
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }